<p-card class="p-card" header="Assets">
  <p-table
  stripedRows
  [value]="assets"
  responsiveLayout="scroll"
  selectionMode="single"
  (onRowSelect)="rowSelected()"
  [(selection)]="selectedAsset"
>
    <ng-template #emptymessage>
      <tr>
          <td colspan="5">No assets found.</td>
      </tr>
  </ng-template>
  
  <!-- Table Header -->
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th>Name</th>
        <th>Key</th>
        <th>MAC</th>
        <th>Type</th>
        <th>Last Seen</th>
        <th>Status</th>
        <th></th>
      </tr>
      </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-rowData>
      <tr [pSelectableRow]="rowData">
        <td>{{rowData.name}}</td>
        <td>{{rowData.asset_key}}</td>
        <td>{{rowData.asset_mac_address}}</td>
        <td>{{rowData.asset_type}}</td>
        <td>
          {{ rowData.integration?.lastSeen | date : "medium" }}
        </td>
        <td>
          <span [ngClass]="rowData.integration?.status === 'active' ? 'green' : rowData.integration?.status === 'disabled' ? 'orange' : 'red'">
            {{ rowData.integration?.status }}
          </span>
        </td>
        <td style="text-align: right;">
          <p-button
            (click)="selectedAsset = rowData; menu.toggle($event)"
            icon="pi pi-ellipsis-v" />
        </td>
        </tr>
    </ng-template>
  </p-table>
  <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
  
</p-card>
